<template>
  <div
    :class="[
      'tw-flex tw-gap-2.5 tw-px-3.5 tw-py-2.5 tw-rounded-lg tw-text-[13px] tw-leading-relaxed',
      typeClasses,
    ]"
  >
    <mdicon v-if="icon" :name="icon" size="16" class="tw-shrink-0 tw-mt-0.5" :class="iconClass" />
    <div class="tw-flex-1 tw-text-nc-medium dark:tw-text-gray-400">
      <slot />
    </div>
  </div>
</template>

<script>
const typeMap = {
  info: 'tw-bg-gray-50 dark:tw-bg-gray-800/50 tw-border tw-border-gray-100 dark:tw-border-gray-700',
  warning: 'tw-bg-amber-50/60 dark:tw-bg-amber-900/10 tw-border tw-border-amber-200/50 dark:tw-border-amber-800/30',
  success: 'tw-bg-emerald-50/60 dark:tw-bg-emerald-900/10 tw-border tw-border-emerald-200/50 dark:tw-border-emerald-800/30',
};

const iconColorMap = {
  info: 'tw-text-nc-medium',
  warning: 'tw-text-amber-500',
  success: 'tw-text-nc-success',
};

export default {
  name: 'NcAlert',
  props: {
    type: { type: String, default: 'info', validator: v => ['info', 'warning', 'success'].includes(v) },
    icon: { type: String, default: '' },
  },
  computed: {
    typeClasses() { return typeMap[this.type]; },
    iconClass() { return iconColorMap[this.type]; },
  },
};
</script>
